<template>
    <div v-loading="isBusy">
        <el-form
                ref="form"
                :model="form"
                :rules="rules"
                element-loading-spinner="el-icon-loading"
                label-width="170px"
        >
            <el-form-item label="Brand" prop="brand_id" required>
                <el-select v-model="form.brand_id">
                    <el-option
                            v-for="item in brandOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Name" prop="name" required>
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item prop="expiry_period">
                <template v-slot:label>
                    <el-tooltip
                            effect="light"
                            content="Period of time in days after which the contact list will be deleted from the system"
                            placement="top-start"
                    >
                        <span>Expiry Period <i class="far fa-question-circle"></i></span>
                    </el-tooltip>
                </template>
                <el-input v-model="form.expiry_period" clearable></el-input>
            </el-form-item>
            <el-form-item label="Import Contacts" prop="contacts_file">
                <div v-if="isFileSelected">
                    <em>{{ this.filename }}</em>
                    <span class="btn btn-link btn-link-red px-1" @click="clearFile"><i class="fas fa-times-circle"></i></span>
                </div>
                <file-input v-else v-model="form.contacts_file" v-slot:default="{clickHandler}">
                    <span @click.prevent="clickHandler" class="btn btn-link btn-link-purple px-0"><i
                            class="fas fa-folder-open"></i></span>
                </file-input>
            </el-form-item>
        </el-form>
        <button class="btn btn-purple px-4" @click="store">Store</button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import FileInput from '../file-input';
  import {isParsableNumber} from "../../helpers";

  export default {
    extends: BaseForm,

    components: {
      FileInput,
    },

    props: {
      brands: Array,
    },

    data() {
      return {
        form: {
          brand_id: null,
          name: null,
          expiry_period: null,
          contacts_file: null,
        },
        rules: {
          brand_id: [{validator: this.fieldExternalValidator}],
          name: [{validator: this.fieldExternalValidator}],
          expiry_period: [{validator: this.fieldExternalValidator}],
          contacts_file: [{validator: this.fieldExternalValidator}],
        },
      }
    },

    computed: {
      /**
       * @return {boolean}
       */
      isFileSelected() {
        return Boolean(_.get(this.form, 'contacts_file', false));
      },

      /**
       * @return {string|null}
       */
      filename() {
        return this.isFileSelected
          ? _.get(this.form, 'contacts_file.name')
          : null;
      },

      /**
       * @return {array}
       */
      brandOptions() {
        return _.map(this.brands || [], item => {
          return {
            value: item.id,
            label: item.title,
          };
        });
      },
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm({brand_id = null, name = null, expiry_period = null}) {
        this.form = {
          brand_id,
          name,
          expiry_period: this.secondsToDays(expiry_period),
          contacts_file: null,
        };
      },

      /**
       * @return {number|undefined}
       */
      secondsToDays(value) {
        if (_.isFinite(value)) {
          return _.floor(moment.duration(value, 'seconds').asDays());
        }
      },

      /**
       * @return {FormData}
       */
      getForm() {
        const form = _.assign({}, this.form, {
          _method: this.method,
          expiry_period: this.daysToSeconds(this.form.expiry_period),
        });

        return this.toFormData(form);
      },

      /**
       * @param {object} data
       * @return {FormData}
       */
      toFormData(data) {
        const formData = new FormData();
        _.each(data, (value, name) => {
          formData.append(name, _.isNull(value) || _.isUndefined(value) ? '' : value);
        });

        return formData;
      },

      /**
       * @return {number|null}
       */
      daysToSeconds(value) {
        if (isParsableNumber(value)) {
          return moment.duration(Number(value), 'days').asSeconds();
        }

        return value;
      },

      /**
       * @return {undefined}
       */
      clearFile() {
        this.form.contacts_file = null;
      },

      /**
       * @return {boolean}
       */
      isFormBusy() {
        return this.isBusy;
      },
    }
  }
</script>

